import { HeliodorSDKVersion, INITIAL_MIXER_DISTANCE_SETTING, INITIAL_MIXER_FADER_SETTING, INITIAL_MIXER_SETTING, worldViewerWindow } from '../const';
/**
 * WorldIdAccessor(GET)
 * @returns String
 */ export const getWorldId = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_WorldID === undefined || worldViewerWindow.g_WorldID === null) {
        return undefined;
    }
    return worldViewerWindow.g_WorldID;
};
/**
 * WorldIdAccessor(SET)
 * @remarks
 * 未使用
 * worldIdがstringでなく入ってくる可能性も考えられるためunknown型で定義
 * front側で設定することが多い。var設定
 * @param worldId グローバルワールドID
 */ export const setWorldId = (worldId)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof worldId !== 'string') {
        return;
    }
    worldViewerWindow.g_WorldID = worldId;
};
/**
 * SkyRoomIdAccessor(GET)
 * TODO 内海 default値がわからないため0にしてる
 * @returns String
 */ export const getSkyRoomId = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_Skyway_RoomID === undefined || worldViewerWindow.g_Skyway_RoomID === null) {
        return '0';
    }
    return worldViewerWindow.g_Skyway_RoomID;
};
/**
 * SkyRoomIdAccessor(SET)
 * @remarks
 * front側で設定することが多い。var設定
 * @param skyRoomId グローバルスカイルームID
 */ export const setSkyRoomId = (skyRoomId)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null) {
        return;
    }
    worldViewerWindow.g_Skyway_RoomID = skyRoomId;
};
/**
 * SpotIdAccessor(GET)
 * @returns String
 */ export const getSpotId = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_Spot === undefined || worldViewerWindow.g_Spot === null) {
        return undefined;
    }
    return worldViewerWindow.g_Spot;
};
/**
 * SpotIdAccessor(SET)
 * @remarks
 * 未使用
 * spotIdがstringでなく入ってくる可能性も考えられるためunknown型で定義
 * front側で設定することが多い。var設定
 * @param spotId グローバルスポットID
 */ export const setSpotId = (spotId)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof spotId !== 'string') {
        return;
    }
    worldViewerWindow.g_Spot = spotId;
};
/**
 * WorldSelectedToggle (GET)
 * @returns Boolean
 */ export const getWorldSelectedToggle = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_ShowWorldSelect === undefined || worldViewerWindow.g_ShowWorldSelect === null) {
        return false;
    }
    return worldViewerWindow.g_ShowWorldSelect;
};
/**
 * WorldSelectedToggle(SET)
 * @remarks
 * 未使用
 * toggleがboolean以外の可能性があるためunknown型に
 * front側で設定することが多い。var設定
 * @param toggle ワールド選択されてるか
 */ export const setWorldSelectedToggle = (toggle)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof toggle !== 'boolean') {
        return;
    }
    worldViewerWindow.g_ShowWorldSelect = toggle;
};
/**
 * LoggedInStatusToggle (GET)
 * @returns Boolean
 */ export const getLoggedInStatusToggle = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_Logined === undefined || worldViewerWindow.g_Logined === null) {
        return false;
    }
    return worldViewerWindow.g_Logined;
};
/**
 * LoggedInStatusToggle(SET)
 * @remarks
 * toggleがbooleanでなく入ってくる可能性も考えられるためunknown型で定義
 *
 * @param toggle ログイン状態
 */ export const setLoggedInStatusToggle = (toggle)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof toggle !== 'boolean') {
        return;
    }
    worldViewerWindow.g_Logined = toggle;
};
/**
 * CanvasName (GET)
 * @returns String
 */ export const getCanvasFileName = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_CanvasFileName === undefined || worldViewerWindow.g_CanvasFileName === null) {
        return '';
    }
    return worldViewerWindow.g_CanvasFileName;
};
/**
 * CanvasName(SET)
 * @remarks
 * updatedCanvasNameがstringでなく入ってくる可能性も考えられるためunknown型で定義
 *
 * @param updatedCanvasName 更新予定のキャンバスファイル名
 */ export const setCanvasFileName = (updatedCanvasName)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof updatedCanvasName !== 'string') {
        return;
    }
    worldViewerWindow.g_CanvasFileName = updatedCanvasName;
};
/**
 * CurrentUserName (GET)
 * @returns String
 */ export const getCurrentUserName = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_CurrentUserName === undefined || worldViewerWindow.g_CurrentUserName === null) {
        return '';
    }
    return worldViewerWindow.g_CurrentUserName;
};
/**
 * CurrentUserName(SET)
 * @remarks
 * updatedCanvasNameがstringでなく入ってくる可能性も考えられるためunknown型で定義
 *
 * @param updatedUserName 更新予定のユーザ名
 */ export const setCurrentUserName = (updatedUserName)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null) {
        return;
    }
    worldViewerWindow.g_CurrentUserName = updatedUserName;
};
/**
 * WebGL10Toggle (GET)
 * @remarks
 * render_calleeのみで利用してる...他と一緒に状態管理してもよいかも
 * @returns Boolean
 */ export const getWebGL10Toggle = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_UseWebGL10 === undefined || worldViewerWindow.g_UseWebGL10 === null) {
        return false;
    }
    return worldViewerWindow.g_UseWebGL10;
};
/**
 * WebGL10Toggle(SET)
 * @remarks
 * updatedMixerTabValueがnumberでなく入ってくる可能性も考えられるためunknown型で定義
 *
 * @param toggle フラグ
 */ export const setWebGL10Toggle = (toggle)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof toggle !== 'boolean') {
        return;
    }
    worldViewerWindow.g_UseWebGL10 = toggle;
};
/**
 * CompressedTexturePvrtc (GET)
 * @remarks
 * render_calleeのみで利用してる...他と一緒に状態管理してもよいかも
 * @returns WEBGL_compressed_texture_pvrtc|undefined
 */ export const getTextureExtOnPvrtc = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_extPVRTC === undefined || worldViewerWindow.g_extPVRTC === null) {
        return undefined;
    }
    return worldViewerWindow.g_extPVRTC;
};
/**
 * CompressedTexturePvrtc(SET)
 * @remarks
 * compressedTexturePvrtc以外が入ってくる可能性も考えられるためunknown型で定義
 *
 * @param compressedTexturePvrtc
 */ export const setTextureExtOnPvrtc = (compressedTexturePvrtc)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || compressedTexturePvrtc === undefined || compressedTexturePvrtc === null) {
        return;
    }
    worldViewerWindow.g_extPVRTC = compressedTexturePvrtc;
};
/**
 * TextureEtc2Toggle (GET)
 * @remarks
 * 未使用
 * render_calleeのみで利用してる...他と一緒に状態管理してもよいかも
 * @returns Boolean
 */ export const getTexturePvrtcToggle = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_TextureCompression_PVRTC === undefined || worldViewerWindow.g_TextureCompression_PVRTC === null) {
        return false;
    }
    return worldViewerWindow.g_TextureCompression_PVRTC;
};
/**
 * TextureEtc2Toggle(SET)
 * @remarks
 * toggleが違う形式で入ってくる可能性も考えられるためunknown型で定義
 *
 * @param toggle
 */ export const setTexturePvrtcToggle = (toggle)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof toggle !== 'boolean') {
        return;
    }
    worldViewerWindow.g_TextureCompression_PVRTC = toggle;
};
/**
 * CompressedTextureEtc2 (GET)
 * @remarks
 * render_calleeのみで利用してる...他と一緒に状態管理してもよいかも
 * @returns WEBGL_compressed_texture_etc|undefined
 */ export const getTextureExtOnETC2 = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_extETC2 === undefined || worldViewerWindow.g_extETC2 === null) {
        return undefined;
    }
    return worldViewerWindow.g_extETC2;
};
/**
 * CompressedTextureEtc2(SET)
 * @remarks
 * compressedTextureEtc2c以外が入ってくる可能性も考えられるためunknown型で定義
 *
 * @param compressedTextureEtc2
 */ export const setTextureExtOnETC2 = (compressedTextureEtc2)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || compressedTextureEtc2 === undefined || compressedTextureEtc2 === null) {
        return;
    }
    worldViewerWindow.g_extETC2 = compressedTextureEtc2;
};
/**
 * TextureEtc2Toggle (GET)
 * @remarks
 * 未使用
 * render_calleeのみで利用してる...他と一緒に状態管理してもよいかも
 * @returns Boolean
 */ export const getTextureETC2Toggle = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_TextureCompression_ETC2 === undefined || worldViewerWindow.g_TextureCompression_ETC2 === null) {
        return false;
    }
    return worldViewerWindow.g_TextureCompression_ETC2;
};
/**
 * TextureEtc2Toggle(SET)
 * @remarks
 * toggleが違う形式で入ってくる可能性も考えられるためunknown型で定義
 *
 * @param toggle
 */ export const setTextureETC2Toggle = (toggle)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof toggle !== 'boolean') {
        return;
    }
    worldViewerWindow.g_TextureCompression_ETC2 = toggle;
};
/**
 * CompressedTextureASTC (GET)
 * @remarks
 * render_calleeのみで利用してる...他と一緒に状態管理してもよいかも
 * @returns WEBGL_compressed_texture_astc|undefined
 */ export const getTextureExtOnAstc = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_extASTC === undefined || worldViewerWindow.g_extASTC === null) {
        return undefined;
    }
    return worldViewerWindow.g_extASTC;
};
/**
 * CompressedTextureASTC(SET)
 * @remarks
 * compressedTextureAstc以外が入ってくる可能性も考えられるためunknown型で定義
 *
 * @param compressedTextureAstc
 */ export const setTextureExtOnAstc = (compressedTextureAstc)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || compressedTextureAstc === undefined || compressedTextureAstc === null) {
        return;
    }
    worldViewerWindow.g_extASTC = compressedTextureAstc;
};
/**
 * TextureASTCToggle (GET)
 * @remarks
 * 未使用
 * render_calleeのみで利用してる...他と一緒に状態管理してもよいかも
 * @returns Boolean
 */ export const getTextureAstcToggle = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_TextureCompression_ASTC === undefined || worldViewerWindow.g_TextureCompression_ASTC === null) {
        return false;
    }
    return worldViewerWindow.g_TextureCompression_ASTC;
};
/**
 * TextureASTCToggle(SET)
 * @remarks
 * boolean以外が違う形式で入ってくる可能性も考えられるためunknown型で定義
 * @param toggle
 */ export const setTextureAstcToggle = (toggle)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof toggle !== 'boolean') {
        return;
    }
    worldViewerWindow.g_TextureCompression_ASTC = toggle;
};
/**
 * CompressedTextureDXT (GET)
 * @remarks
 * render_calleeのみで利用してる...他と一緒に状態管理してもよいかも
 * @returns any|undefined
 */ export const getTextureExtOnDxt = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_extDXT === undefined || worldViewerWindow.g_extDXT === null) {
        return undefined;
    }
    return worldViewerWindow.g_extDXT;
};
/**
 * CompressedTextureDXT(SET)
 * @remarks
 * compressedTextureDxt以外が入ってくる可能性も考えられるためunknown型で定義
 *
 * @param compressedTextureDxt
 */ export const setTextureExtOnDxt = (compressedTextureDxt)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || compressedTextureDxt === undefined || compressedTextureDxt === null) {
        return;
    }
    worldViewerWindow.g_extDXT = compressedTextureDxt;
};
/**
 * TextureDXTToggle (GET)
 * @remarks
 * 未使用
 * render_calleeのみで利用してる...他と一緒に状態管理してもよいかも
 * @returns Boolean
 */ export const getTextureDxtToggle = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_TextureCompression_DXT === undefined || worldViewerWindow.g_TextureCompression_DXT === null) {
        return false;
    }
    return worldViewerWindow.g_TextureCompression_DXT;
};
/**
 * TextureDXTToggle(SET)
 * @remarks
 * boolean以外が違う形式で入ってくる可能性も考えられるためunknown型で定義
 * @param toggle
 */ export const setTextureDxtToggle = (toggle)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof toggle !== 'boolean') {
        return;
    }
    worldViewerWindow.g_TextureCompression_DXT = toggle;
};
/**
 * ExtensionShaderTextureLod (GET)
 * @remarks
 * render_calleeのみで利用してる...他と一緒に状態管理してもよいかも
 * @returns EXT_shader_texture_lod|undefined
 */ export const getExtShaderTextureLod = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_EXT_shader_texture_lod === undefined || worldViewerWindow.g_EXT_shader_texture_lod === null) {
        return undefined;
    }
    return worldViewerWindow.g_EXT_shader_texture_lod;
};
/**
 * ExtensionShaderTextureLod(SET)
 * @remarks
 * extShaderTextureLod以外が入ってくる可能性も考えられるためunknown型で定義
 *
 * @param extShaderTextureLod
 */ export const setExtShaderTextureLod = (extShaderTextureLod)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || extShaderTextureLod === undefined || extShaderTextureLod === null) {
        return;
    }
    worldViewerWindow.g_EXT_shader_texture_lod = extShaderTextureLod;
};
/**
 * ExtShaderTextureLodToggle (GET)
 * @remarks
 * 未使用
 * render_calleeのみで利用してる...他と一緒に状態管理してもよいかも
 * @returns Boolean
 */ export const getExtShaderTextureLodToggle = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_Use_EXT_shader_texture_lod === undefined || worldViewerWindow.g_Use_EXT_shader_texture_lod === null) {
        return false;
    }
    return worldViewerWindow.g_Use_EXT_shader_texture_lod;
};
/**
 * ExtShaderTextureLodToggle(SET)
 * @remarks
 * boolean以外が違う形式で入ってくる可能性も考えられるためunknown型で定義
 * @param toggle
 */ export const setExtShaderTextureLodToggle = (toggle)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof toggle !== 'boolean') {
        return;
    }
    worldViewerWindow.g_Use_EXT_shader_texture_lod = toggle;
};
/**
 * ExtColorBufferHalfFloat (GET)
 * @remarks
 * render_calleeのみで利用してる...他と一緒に状態管理してもよいかも
 * @returns EXT_color_buffer_half_float|undefined
 */ export const getExtColorBufferHalfFloat = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_EXT_color_buffer_half_float === undefined || worldViewerWindow.g_EXT_color_buffer_half_float === null) {
        return undefined;
    }
    return worldViewerWindow.g_EXT_color_buffer_half_float;
};
/**
 * ExtColorBufferHalfFloat(SET)
 * @remarks
 * extColorBufferHalfFloat以外が入ってくる可能性も考えられるためunknown型で定義
 *
 * @param extColorBufferHalfFloat
 */ export const setExtColorBufferHalfFloat = (extColorBufferHalfFloat)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || extColorBufferHalfFloat === undefined || extColorBufferHalfFloat === null) {
        return;
    }
    worldViewerWindow.g_EXT_color_buffer_half_float = extColorBufferHalfFloat;
};
/**
 * ExtColorBufferHalfFloatToggle (GET)
 * @remarks
 * 未使用
 * render_calleeのみで利用してる...他と一緒に状態管理してもよいかも
 * @returns Boolean
 */ export const getExtColorBufferHalfFloatToggle = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_Use_EXT_color_buffer_half_float === undefined || worldViewerWindow.g_Use_EXT_color_buffer_half_float === null) {
        return false;
    }
    return worldViewerWindow.g_Use_EXT_color_buffer_half_float;
};
/**
 * ExtColorBufferHalfFloatToggle(SET)
 * @remarks
 * boolean以外が違う形式で入ってくる可能性も考えられるためunknown型で定義
 * @param toggle
 */ export const setExtColorBufferHalfFloatToggle = (toggle)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof toggle !== 'boolean') {
        return;
    }
    worldViewerWindow.g_Use_EXT_color_buffer_half_float = toggle;
};
/**
 * OesTextureHalfFloat (GET)
 * @remarks
 * render_calleeのみで利用してる...他と一緒に状態管理してもよいかも
 * @returns OES_texture_half_float|undefined
 */ export const getOesTextureHalfFloat = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_OES_texture_half_float === undefined || worldViewerWindow.g_OES_texture_half_float === null) {
        return undefined;
    }
    return worldViewerWindow.g_OES_texture_half_float;
};
/**
 * OesTextureHalfFloat(SET)
 * @remarks
 * oesTextureHalfFloat以外が入ってくる可能性も考えられるためunknown型で定義
 *
 * @param oesTextureHalfFloat
 */ export const setOesTextureHalfFloat = (oesTextureHalfFloat)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || oesTextureHalfFloat === undefined || oesTextureHalfFloat === null) {
        return;
    }
    worldViewerWindow.g_OES_texture_half_float = oesTextureHalfFloat;
};
/**
 * OesTextureHalfFloatToggle (GET)
 * @remarks
 * 未使用
 * render_calleeのみで利用してる...他と一緒に状態管理してもよいかも
 * @returns Boolean
 */ export const getOesTextureHalfFloatToggle = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_Use_OES_texture_half_float === undefined || worldViewerWindow.g_Use_OES_texture_half_float === null) {
        return false;
    }
    return worldViewerWindow.g_Use_OES_texture_half_float;
};
/**
 * OesTextureHalfFloatToggle(SET)
 * @remarks
 * boolean以外が違う形式で入ってくる可能性も考えられるためunknown型で定義
 * @param toggle
 */ export const setOesTextureHalfFloatToggle = (toggle)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof toggle !== 'boolean') {
        return;
    }
    worldViewerWindow.g_Use_OES_texture_half_float = toggle;
};
/**
 * MixerTab (GET)
 * @remarks
 * 状態管理であるためシングルトンのように持ちたいかも
 * @returns Number(decimal)
 */ export const getMixerTab = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_hel_MixerTabActive === undefined || worldViewerWindow.g_hel_MixerTabActive === null) {
        return 1.0;
    }
    return worldViewerWindow.g_hel_MixerTabActive;
};
/**
 * MixerTab(SET)
 * @remarks
 * updatedMixerTabValueがnumberでなく入ってくる可能性も考えられるためunknown型で定義
 *
 * @param updatedMixerTabValue 更新予定のMixerタブ値
 */ export const setMixerTab = (updatedMixerTabValue)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof updatedMixerTabValue !== 'number') {
        return;
    }
    worldViewerWindow.g_hel_MixerTabActive = updatedMixerTabValue;
};
/**
 * Mixer (GET)
 * @param index
 * @returns Number
 */ export const getMixerSettingAt = (index)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_hel_Mixer === undefined || worldViewerWindow.g_hel_Mixer === null) {
        return INITIAL_MIXER_SETTING[index];
    }
    return worldViewerWindow.g_hel_Mixer[index];
};
/**
 * Mixer(SET)
 * @param volume ボリューム。decimal
 * @param typeIndex 指定インデックス。0より
 */ export const setMixerSettingAt = (volume, typeIndex)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null) {
        return;
    }
    worldViewerWindow.g_hel_Mixer[typeIndex] = volume;
};
/**
 * MixerFader (GET)
 * @param index
 * @returns Number
 */ export const getMixerFaderSettingAt = (index)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_hel_MixerFade === undefined || worldViewerWindow.g_hel_MixerFade === null) {
        return INITIAL_MIXER_FADER_SETTING[index];
    }
    return worldViewerWindow.g_hel_MixerFade[index];
};
/**
 * MixerFader(SET)
 * @param volume ボリューム。decimal
 * @param typeIndex 指定インデックス。0より
 */ export const setMixerFaderSettingAt = (volume, typeIndex)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null) {
        return;
    }
    worldViewerWindow.g_hel_MixerFade[typeIndex] = volume;
};
/**
 * MixerDistance (GET)
 * @param index
 * @returns Number
 */ export const getMixerDistanceAt = (index)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_hel_MixerDistance === undefined || worldViewerWindow.g_hel_MixerDistance === null) {
        return INITIAL_MIXER_DISTANCE_SETTING[index];
    }
    return worldViewerWindow.g_hel_MixerDistance[index];
};
/**
 * MixerDistance(SET)
 * @param volume ボリューム。decimal
 * @param typeIndex 指定インデックス。0より
 */ export const setMixerDistanceAt = (volume, typeIndex)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null) {
        return;
    }
    worldViewerWindow.g_hel_MixerDistance[typeIndex] = volume;
};
/**
 * MixerMute (GET)
 * @param index
 * @returns Number
 */ export const getMixerMuteAt = (index)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_hel_MixerMute === undefined || worldViewerWindow.g_hel_MixerMute === null) {
        return INITIAL_MIXER_DISTANCE_SETTING[index];
    }
    return worldViewerWindow.g_hel_MixerMute[index];
};
/**
 * MixerMute(SET)
 * @param volume ボリューム。decimal
 * @param typeIndex 指定インデックス。0より
 */ export const setMixerMuteAt = (volume, typeIndex)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null) {
        return;
    }
    worldViewerWindow.g_hel_MixerMute[typeIndex] = volume;
};
/**
 * UseLegacyAudioToggle (GET)
 * @returns Boolean
 */ export const getUseLegacyAudioToggle = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_hel_UseLegacyAudio === undefined || worldViewerWindow.g_hel_UseLegacyAudio === null) {
        return false;
    }
    return worldViewerWindow.g_hel_UseLegacyAudio;
};
/**
 * UseLegacyAudioToggle(SET)
 * @remarks
 * 未使用
 * boolean以外が違う形式で入ってくる可能性も考えられるためunknown型で定義
 * @param toggle
 */ export const setUseLegacyAudioToggle = (toggle)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof toggle !== 'boolean') {
        return;
    }
    worldViewerWindow.g_hel_UseLegacyAudio = toggle;
};
/**
 * AudioList (GET)
 * @returns (CHELAudio|null)[]
 */ export const getAudioList = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_audioList === undefined || worldViewerWindow.g_audioList === null) {
        return [];
    }
    return worldViewerWindow.g_audioList;
};
/**
 * AudioList(SET)
 * @remarks
 * 必要あればnullを設定
 * @param audio CHELAudioインスタンス
 * @param index 設定可能なインデックス
 */ export const setAudioList = (audio, index)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_audioList === undefined || worldViewerWindow.g_audioList === null) {
        return;
    }
    worldViewerWindow.g_audioList[index] = audio;
};
/**
 * AudioListに処理の流れ上Nullを設定
 */ export const pushNullToAudioList = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_audioList === undefined || worldViewerWindow.g_audioList === null) {
        return;
    }
    worldViewerWindow.g_audioList.push(null);
};
/**
 * VideoCanPlayToggle (GET)
 * @remarks
 * 未使用
 * @returns Boolean
 */ export const getVideoCanPlayToggle = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_videocanplay === undefined || worldViewerWindow.g_videocanplay === null) {
        return false;
    }
    return worldViewerWindow.g_videocanplay;
};
/**
 * VideoCanPlayToggle(SET)
 * boolean以外が違う形式で入ってくる可能性も考えられるためunknown型で定義
 * @param toggle
 */ export const setVideoCanPlayToggle = (toggle)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof toggle !== 'boolean') {
        return;
    }
    worldViewerWindow.g_videocanplay = toggle;
};
/**
 * VideoEndedToggle (GET)
 * @returns Boolean
 */ export const getVideoEndedToggle = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_videoended === undefined || worldViewerWindow.g_videoended === null) {
        return false;
    }
    return worldViewerWindow.g_videoended;
};
/**
 * VideoEndedToggle(SET)
 * boolean以外が違う形式で入ってくる可能性も考えられるためunknown型で定義
 * @param toggle
 */ export const setVideoEndedToggle = (toggle)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof toggle !== 'boolean') {
        return;
    }
    worldViewerWindow.g_videoended = toggle;
};
/**
 * VideoAudioContext (GET)
 * @returns AudioContext|undefined
 */ export const getVideoAudioContext = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_VideoAudioContext === undefined || worldViewerWindow.g_VideoAudioContext === null) {
        return undefined;
    }
    return worldViewerWindow.g_VideoAudioContext;
};
/**
 * VideoAudioContext (SET)
 * @param videoAudioContext AudioContext型
 */ export const setVideoAudioContext = (videoAudioContext)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || videoAudioContext === undefined || videoAudioContext === null) {
        return;
    }
    worldViewerWindow.g_VideoAudioContext = videoAudioContext;
};
/**
 * VideoSource (GET)
 * @returns MediaElementAudioSourceNode|undefined
 */ export const getVideoSource = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_VideoSource === undefined || worldViewerWindow.g_VideoSource === null) {
        return undefined;
    }
    return worldViewerWindow.g_VideoSource;
};
/**
 * VideoSource (SET)
 * @param videoSource MediaElementAudioSourceNode
 */ export const setVideoSource = (videoSource)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || videoSource === undefined || videoSource === null) {
        return;
    }
    worldViewerWindow.g_VideoSource = videoSource;
};
/**
 * VideoGainNode (GET)
 * @returns GainNode|undefined
 */ export const getVideoGainNode = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_VideoGainNode === undefined || worldViewerWindow.g_VideoGainNode === null) {
        return undefined;
    }
    return worldViewerWindow.g_VideoGainNode;
};
/**
 * VideoGainNode (SET)
 * @param gainNode GainNode
 */ export const setVideoGainNode = (gainNode)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || gainNode === undefined || gainNode === null) {
        return;
    }
    worldViewerWindow.g_VideoGainNode = gainNode;
};
/**
 * VideoHlsConfig (GET)
 * @returns HlsConfig|undefined
 */ export const getVideoHlsConfig = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_VideoHlsConfig === undefined || worldViewerWindow.g_VideoHlsConfig === null) {
        return undefined;
    }
    return worldViewerWindow.g_VideoHlsConfig;
};
/**
 * VideoHlsConfig (SET)
 * @param updatedConfig HlsConfig
 */ export const setVideoHlsConfig = (updatedConfig)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || updatedConfig === undefined || updatedConfig === null) {
        return;
    }
    worldViewerWindow.g_VideoHlsConfig = updatedConfig;
};
/**
 * TextureCanvasList (GET)
 * @returns (CHELAudio|null)[]
 */ export const getTextureCanvasList = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_TextCanvasList === undefined || worldViewerWindow.g_TextCanvasList === null) {
        return [];
    }
    return worldViewerWindow.g_TextCanvasList;
};
/**
 * TextureCanvasList(SET)
 * @remarks
 * 必要あればnullを設定
 * @param textureCanvas HTMLCanvasElementインスタンス
 * @param index 設定可能なインデックス
 */ export const setTextureCanvasList = (textureCanvas, index)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_TextCanvasList === undefined || worldViewerWindow.g_TextCanvasList === null) {
        return;
    }
    worldViewerWindow.g_TextCanvasList[index] = textureCanvas;
};
/**
 * ATextureCanvasListに処理の流れ上Nullを設定
 */ export const pushNullToTextureCanvasList = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_TextCanvasList === undefined || worldViewerWindow.g_TextCanvasList === null) {
        return;
    }
    worldViewerWindow.g_TextCanvasList.push(null);
};
/**
 * GyroActiveToggle (GET)
 * @returns Boolean
 */ export const getGyroActiveToggle = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_GyroActive === undefined || worldViewerWindow.g_GyroActive === null) {
        return false;
    }
    return worldViewerWindow.g_GyroActive;
};
/**
 * GyroActiveToggle(SET)
 * boolean以外が違う形式で入ってくる可能性も考えられるためunknown型で定義
 * @param toggle
 */ export const setGyroActiveToggle = (toggle)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof toggle !== 'boolean') {
        return;
    }
    worldViewerWindow.g_GyroActive = toggle;
};
/**
 * UploadedFileBuffer (GET)
 * @remarks
 * 未使用
 * @returns string|ArrayBuffer|undefined
 */ export const getUploadedFileBuffer = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_hel_UploadFileImage === undefined || worldViewerWindow.g_hel_UploadFileImage === null) {
        return undefined;
    }
    return worldViewerWindow.g_hel_UploadFileImage;
};
/**
 * UploadedFileBuffer (SET)
 * @param buffer String型 | ArrayBuffer型 | Null
 */ export const setUploadedFileBuffer = (buffer)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null) {
        return;
    }
    worldViewerWindow.g_hel_UploadFileImage = buffer;
};
/**
 * VCUID (GET)
 * @returns String|undefined
 */ export const getVCUID = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_VCUID === undefined || worldViewerWindow.g_VCUID === null || worldViewerWindow.g_VCUID.length === 0) {
        return undefined;
    }
    return worldViewerWindow.g_VCUID;
};
/**
 * VCUID (SET)
 * @param vcuid unknown
 */ export const setVCUID = (vcuid)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof vcuid !== 'string') {
        return;
    }
    worldViewerWindow.g_VCUID = vcuid;
};
/**
 * Peer (GET)
 * @returns Peer|undefined
 */ export const getPeer = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_peer === undefined || worldViewerWindow.g_peer === null) {
        return undefined;
    }
    return worldViewerWindow.g_peer;
};
/**
 * Peer (SET)
 * @param peer Peer
 */ export const setPeer = (peer)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || peer === undefined || peer === null) {
        return;
    }
    worldViewerWindow.g_peer = peer;
};
/**
 * SkywayName (GET)
 * @returns String
 */ export const getSkywayName = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_Skyway_MyName === undefined || worldViewerWindow.g_Skyway_MyName === null || worldViewerWindow.g_Skyway_MyName.length === 0) {
        return 'Me';
    }
    return worldViewerWindow.g_Skyway_MyName;
};
/**
 * SkywayName (SET)
 * @param name unknown
 */ export const setSkywayName = (name)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof name !== 'string') {
        return;
    }
    worldViewerWindow.g_Skyway_MyName = name;
};
/**
 * LocalStream (GET)
 * @returns MediaStream|undefined
 */ export const getLocalStream = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_localStream === undefined || worldViewerWindow.g_localStream === null) {
        return undefined;
    }
    return worldViewerWindow.g_localStream;
};
/**
 * LocalStream (SET)
 * @param mediaStream MediaStream
 */ export const setLocalStream = (mediaStream)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || mediaStream === undefined || mediaStream === null) {
        return;
    }
    worldViewerWindow.g_localStream = mediaStream;
};
/**
 * SkywayKey (GET)
 * @returns String
 */ export const getSkywayKey = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_SKYWAY_KEY === undefined || worldViewerWindow.g_SKYWAY_KEY === null || worldViewerWindow.g_SKYWAY_KEY.length === 0) {
        return '37825849-7771-49bd-890e-61971fb4f431';
    }
    return worldViewerWindow.g_SKYWAY_KEY;
};
/**
 * SkywayKey (SET)
 * @remarks
 * 未使用
 * @param key unknown
 */ export const setSkywayKey = (key)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof key !== 'string') {
        return;
    }
    worldViewerWindow.g_SKYWAY_KEY = key;
};
/**
 * MeshSkywayRoom (GET)
 * @returns MeshRoom|undefined
 */ export const getSkywayRoom = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_room === undefined || worldViewerWindow.g_room === null) {
        return undefined;
    }
    return worldViewerWindow.g_room;
};
/**
 * MeshSkywayRoom (SET)
 * @param meshRoom MeshRoom
 */ export const setSkywayRoom = (meshRoom)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || meshRoom === undefined || meshRoom === null) {
        return;
    }
    worldViewerWindow.g_room = meshRoom;
};
/**
 * SkywayAvatarNum(GET)
 * @remarks
 * 未使用
 * @returns Number
 */ export const getSkywayAvatarNumber = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_Skyway_MyAvatar === undefined || worldViewerWindow.g_Skyway_MyAvatar === null) {
        return 0;
    }
    return worldViewerWindow.g_Skyway_MyAvatar;
};
/**
 * SkywayAvatarNum(SET)
 * @remarks
 * avatarNumがnumberでなく入ってくる可能性も考えられるためunknown型で定義
 *
 * @param avatarNum アバター番号
 */ export const setSkywayAvatarNumber = (avatarNum)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null) {
        return;
    }
    worldViewerWindow.g_Skyway_MyAvatar = avatarNum;
};
/**
 * SkywayAvatarNum(GET)
 * @returns Number
 */ export const getSkywayAvatarNumberForSend = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_Skyway_MyAvatar_ForSend === undefined || worldViewerWindow.g_Skyway_MyAvatar_ForSend === null) {
        return 0;
    }
    return worldViewerWindow.g_Skyway_MyAvatar_ForSend;
};
/**
 * SkywayAvatarNum(SET)
 * @remarks
 * avatarNumがnumberでなく入ってくる可能性も考えられるためunknown型で定義
 *
 * @param avatarNum アバター番号
 */ export const setSkywayAvatarNumberForSend = (avatarNum)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null) {
        return;
    }
    worldViewerWindow.g_Skyway_MyAvatar_ForSend = avatarNum;
};
/**
 * SkywayStartToggle (GET)
 * @returns Boolean
 */ export const getSkywayStartToggle = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_Skyway_Start === undefined || worldViewerWindow.g_Skyway_Start === null) {
        return false;
    }
    return worldViewerWindow.g_Skyway_Start;
};
/**
 * SkywayStartToggle(SET)
 * boolean以外が違う形式で入ってくる可能性も考えられるためunknown型で定義
 * @remarks
 * 未使用
 * @param toggle
 */ export const setSkywayStartToggle = (toggle)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof toggle !== 'boolean') {
        return;
    }
    worldViewerWindow.g_Skyway_Start = toggle;
};
/**
 * SkywayMicStateTimer (GET)
 * @returns NodeJS.Timer|undefined
 */ export const getSkywayMicStateTimer = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_skyway_set_mic_state_timer === undefined || worldViewerWindow.g_skyway_set_mic_state_timer === null) {
        return undefined;
    }
    return worldViewerWindow.g_skyway_set_mic_state_timer;
};
/**
 * SkywayMicStateTimer (SET)
 * @param timer NodeJS.Timer
 */ export const setSkywayMicStateTimer = (timer)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || timer === undefined || timer === null) {
        return;
    }
    worldViewerWindow.g_skyway_set_mic_state_timer = timer;
};
/**
 * SkywayPlayerList (GET)
 * @returns (CHELSkywayPlayer|null)[]
 */ export const getSkywayPlayerList = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_SkywayPlayerList === undefined || worldViewerWindow.g_SkywayPlayerList === null) {
        return [];
    }
    return worldViewerWindow.g_SkywayPlayerList;
};
/**
 * SkywayPlayerList(SET)
 * @remarks
 * 必要あればnullを設定
 * @param skywayPlayer CHELSkywayPlayerインスタンス
 * @param index 設定可能なインデックス
 */ export const setSkywayPlayerList = (skywayPlayer, index)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_SkywayPlayerList === undefined || worldViewerWindow.g_SkywayPlayerList === null) {
        return;
    }
    worldViewerWindow.g_SkywayPlayerList[index] = skywayPlayer;
};
/**
 * XrwFriendCode (GET)
 * @remarks
 * XRWorldIngameにて定義あり（helidor_front.js)
 * heliodor.jsやCPP側でも参照あるため定義は必要
 *
 * @returns String
 */ export const getXrwFriendCode = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_xrwFriendCode === undefined || worldViewerWindow.g_xrwFriendCode === null || worldViewerWindow.g_xrwFriendCode.length === 0) {
        return '';
    }
    return worldViewerWindow.g_xrwFriendCode;
};
/**
 * XrwFriendCode (SET)
 * @remarks
 * 未使用
 * XRWorldIngameにて定義あり（helidor_front.js)
 * heliodor.jsやCPP側でも参照あるため定義は必要
 *
 * @param key unknown
 */ export const setXrwFriendCode = (key)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof key !== 'string') {
        return;
    }
    worldViewerWindow.g_xrwFriendCode = key;
};
/**
 * XrwDataFolderName (GET)
 * @remarks
 * XRWorldIngameにて定義あり（helidor_front.js)
 *
 * @returns String
 */ export const getXrwDataFolderName = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_DataFolderName === undefined || worldViewerWindow.g_DataFolderName === null || worldViewerWindow.g_DataFolderName.length === 0) {
        return '';
    }
    return worldViewerWindow.g_DataFolderName;
};
/**
 * XrwDataFolderName (SET)
 * @remarks
 * 未使用
 * XRWorldIngameにて定義あり（helidor_front.js)
 *
 * @param key unknown
 */ export const setXrwDataFolderName = (key)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof key !== 'string') {
        return;
    }
    worldViewerWindow.g_DataFolderName = key;
};
/**
 * UseSkywayAudioGainToggle (GET)
 * @remarks
 * 未使用
 * XRWorldIngameにて定義あり（helidor_skyway_xrw.js)
 * @returns Boolean
 */ export const getUseSkywayAudioGainToggle = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_hel_UseSkywayAudioGain === undefined || worldViewerWindow.g_hel_UseSkywayAudioGain === null) {
        return false;
    }
    return worldViewerWindow.g_hel_UseSkywayAudioGain;
};
/**
 * UseSkywayAudioGainToggle(SET)
 * boolean以外が違う形式で入ってくる可能性も考えられるためunknown型で定義
 * @remarks
 * 未使用
 * XRWorldIngameにて定義あり（helidor_skyway_xrw.js)
 * @param toggle
 */ export const setUseSkywayAudioGainToggle = (toggle)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof toggle !== 'boolean') {
        return;
    }
    worldViewerWindow.g_hel_UseSkywayAudioGain = toggle;
};
/**
 * SceneJson (GET)
 * @remarks
 * @returns any
 */ export const getSceneJson = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_SceneJson === undefined || worldViewerWindow.g_SceneJson === null) {
        return;
    }
    return worldViewerWindow.g_SceneJson;
};
/**
 * SceneJson (SET)
 * @remarks
 * @param json
 */ export const setSceneJson = (json)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof json !== 'string') {
        return;
    }
    worldViewerWindow.g_SceneJson = json;
};
/**
 * SceneJsonPath (GET)
 * @remarks
 * @returns string
 */ export const getSceneJsonPath = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_SceneJsonPath === undefined || worldViewerWindow.g_SceneJsonPath === null) {
        return;
    }
    return worldViewerWindow.g_SceneJsonPath;
};
/**
 * SceneJsonPath (SET)
 * @remarks
 * @param path
 */ export const setSceneJsonPath = (path)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof path !== 'string') {
        return;
    }
    worldViewerWindow.g_SceneJsonPath = path;
};
/**
 * VideoInfo (GET)
 * @remarks
 * @returns any
 */ export const getVideoInfo = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_VideoInfo === undefined || worldViewerWindow.g_VideoInfo === null) {
        return;
    }
    return worldViewerWindow.g_VideoInfo;
};
/**
 * VideoInfo (SET)
 * @remarks
 * @param json
 */ export const setVideoInfo = (json)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof json !== 'string') {
        return;
    }
    worldViewerWindow.g_VideoInfo = json;
};
/**
 * VideoSourceUrl (GET)
 * @remarks
 * @returns Streaming Video URL
 */ export const getVideoSourceUrl = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_VideoSourceUrl === undefined || worldViewerWindow.g_VideoSourceUrl === null) {
        return;
    }
    return worldViewerWindow.g_VideoSourceUrl;
};
/**
 * VideoSourceUrl (SET)
 * @remarks
 * @param url Streaming Video Url
 */ export const setVideoSourceUrl = (url)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof url !== 'string') {
        return;
    }
    worldViewerWindow.g_VideoSourceUrl = url;
};
/**
 * SkywayOnScreenShareStarted (GET)
 * @remarks
 * @returns 画面共有の開始連絡を受け取ったときに呼ばれる関数
 */ export const getSkywayOnScreenShareStarted = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_hel_OnScreenStaredFunction === undefined || worldViewerWindow.g_hel_OnScreenStaredFunction === null) {
        return;
    }
    return worldViewerWindow.g_hel_OnScreenStaredFunction;
};
/**
 * SkywayOnScreenShareStarted (SET)
 * @remarks
 * @param fn 画面共有の開始連絡を受け取ったときに呼ばれる関数
 */ export const setSkywayOnScreenShareStarted = (fn)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof fn !== 'function') {
        return;
    }
    worldViewerWindow.g_hel_OnScreenStaredFunction = fn;
};
/**
 * SkywayOnScreenShareStarted (GET)
 * @remarks
 * @returns 画面共有の開始連絡を受け取ったときに呼ばれる関数
 */ export const getHeliodorSdkVersion = ()=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || worldViewerWindow.g_HeliodorSDKVersion === undefined || worldViewerWindow.g_HeliodorSDKVersion === null) {
        return HeliodorSDKVersion;
    }
    return worldViewerWindow.g_HeliodorSDKVersion;
};
/**
 * SkywayOnScreenShareStarted (SET)
 * @remarks
 * @param version SDKバージョン
 */ export const setHeliodorSdkVersion = (version)=>{
    if (worldViewerWindow === undefined || worldViewerWindow === null || typeof version !== 'string') {
        return;
    }
    worldViewerWindow.g_HeliodorSDKVersion = version;
};
